import { render } from "./Loader.vue?vue&type=template&id=4d9f34c8&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=4d9f34c8&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9f34c8"]])

export default __exports__